<template>
  <div class="wrapper">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
a {
  cursor: pointer;
}

.container__full-width {
  margin: 0;
  max-width: none;
  background: #eff3f6;
}

.bg-dark {
  background: #1d2631;
}

.canvas-container {
  margin: 0 auto 2em auto;
}

table {
  margin: 0;
  padding: 1em 1em 0 1em;
  background: white;
}

tr:last-of-type td {
  border-bottom: none;
  /* padding-bottom: 0.2rem; */
}

button,
input[type="submit"] {
  background-color: #d0011b;
  border: 1px solid #d0011b;
}

.button[disabled],
button[disabled],
input[type="button"][disabled],
input[type="reset"][disabled],
input[type="submit"][disabled] {
  cursor: default;
  /* opacity: 0.5; */
  border-color: transparent;
  background: rgb(198, 204, 207);
}

input[type="email"]:focus,
input[type="number"]:focus,
input[type="password"]:focus,
input[type="search"]:focus,
input[type="tel"]:focus,
input[type="text"]:focus,
input[type="url"]:focus,
textarea:focus,
select:focus {
  border-color: #d0011b;
  outline: 0;
}

.input-group {
  display: flex;
}

.input-group select,
.input-group input {
  width: 50%;
}

.container--section {
  margin: 0 0 2em 0;
  padding: 1em;
}

.container--section input[type="text"],
.container--section input[type="email"],
.container--section select {
  background: #f5f8fa;
}

.wrapper > .container {
  padding-bottom: 7.5rem;
  padding-top: 7.5rem;
}

@media (max-width: 910px) {
  .canvas-container {
    display: none !important;
  }

  #clock {
    display: none !important;
  }

  #legend {
    display: none !important;
  }
}

.v--modal-overlay {
  background: rgba(0, 0, 0, 0.65);
}

.hide-td {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue